import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const ConfirmationPage = () => {
  return (
    <Box
      sx={{
        margin: '30vh auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Typography variant="h4" component="h1" textAlign="center">
        Registrierung erfolgreich!
      </Typography>
      <Typography variant="body1" textAlign="center">
        Bitte prüfe deine E-Mails, um die Registrierung abzuschließen.
      </Typography>
      <Button component={Link} to="/" variant="contained">
        Zurück zur Startseite
      </Button>
    </Box>
  );
};

export default ConfirmationPage;
